/* ----------------------------------------------------------------------------
  BiologicalSex
---------------------------------------------------------------------------- */
export const BIOLOGICAL_SEX_VALUES = ['MALE', 'FEMALE'] as const;

export type BiologicalSex = EnumFromMembers<typeof BIOLOGICAL_SEX_VALUES>;

export const BIOLOGICAL_SEX_LABELS: EnumLabels<BiologicalSex> = {
  MALE: 'Male',
  FEMALE: 'Female',
};

export const BIOLOGICAL_SEX_OPTIONS: FormSelectOptionsFor<typeof BIOLOGICAL_SEX_VALUES> = [
  { value: 'MALE', label: BIOLOGICAL_SEX_LABELS.MALE },
  { value: 'FEMALE', label: BIOLOGICAL_SEX_LABELS.FEMALE },
];

/* ----------------------------------------------------------------------------
  PayorType
---------------------------------------------------------------------------- */
export enum PayorType {
  INSTITUTIONAL = 'INSTITUTIONAL',
  INSURANCE = 'INSURANCE',
  SELF = 'SELF',
}

/* ----------------------------------------------------------------------------
  Relationship (BiologicalRelationshipExtended — up to 4th degree)
---------------------------------------------------------------------------- */
export const EXTENDED_RELATIONSHIP_VALUES = [
  'PARENT',
  'CHILD',
  'SIBLING',
  'FIRST_COUSIN',
  'GRANDPARENT',
  'GRANDCHILD',
  'AUNT_UNCLE',
  'NIECE_NEPHEW',
  'HALF_SIBLING',
  'OTHER',
] as const;

export type ExtendedRelationship = EnumFromMembers<typeof EXTENDED_RELATIONSHIP_VALUES>;

export const EXTENDED_RELATIONSHIP_LABELS: EnumLabels<ExtendedRelationship> = {
  PARENT: 'Parent',
  CHILD: 'Child',
  SIBLING: 'Sibling',
  FIRST_COUSIN: '1st Cousin',
  GRANDPARENT: 'Grandparent',
  GRANDCHILD: 'Grandchild',
  AUNT_UNCLE: 'Aunt/Uncle',
  NIECE_NEPHEW: 'Niece/Nephew',
  HALF_SIBLING: 'Half-Sibling',
  OTHER: 'Other (up to 4th degree)',
};

export const EXTENDED_RELATIONSHIP_OPTIONS: FormSelectOptionsFor<typeof EXTENDED_RELATIONSHIP_VALUES> = [
  { value: 'PARENT', label: EXTENDED_RELATIONSHIP_LABELS.PARENT },
  { value: 'CHILD', label: EXTENDED_RELATIONSHIP_LABELS.CHILD },
  { value: 'SIBLING', label: EXTENDED_RELATIONSHIP_LABELS.SIBLING },
  { value: 'FIRST_COUSIN', label: EXTENDED_RELATIONSHIP_LABELS.FIRST_COUSIN },
  { value: 'GRANDPARENT', label: EXTENDED_RELATIONSHIP_LABELS.GRANDPARENT },
  { value: 'GRANDCHILD', label: EXTENDED_RELATIONSHIP_LABELS.GRANDCHILD },
  { value: 'AUNT_UNCLE', label: EXTENDED_RELATIONSHIP_LABELS.AUNT_UNCLE },
  { value: 'NIECE_NEPHEW', label: EXTENDED_RELATIONSHIP_LABELS.NIECE_NEPHEW },
  { value: 'HALF_SIBLING', label: EXTENDED_RELATIONSHIP_LABELS.HALF_SIBLING },
  { value: 'OTHER', label: EXTENDED_RELATIONSHIP_LABELS.OTHER },
];
